import React, { useRef, useState } from "react";
import {
  ArrowDownCircleIcon,
  PresentationChartLineIcon,
} from "@heroicons/react/24/solid";
import { CSVLink } from "react-csv";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import useGetDigitalAssetsReport from "./hooks/useGetDigitalAssetsReport";
import { useRecoilState, useRecoilValue } from "recoil";
import { mainSelectedTab } from "../../atoms";
import { useHistory } from "react-router-dom";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import Tooltip from "react-tooltip";
import { TooltipPosition } from "chart.js";
import DownloadButton from "../../../../components/DownloadButton";

interface DigitalAssetsReportProps {}
export const DigitalAssetsReport: React.FC<DigitalAssetsReportProps> = () => {
  const { data: allDigitalAssets, isLoading: allDigitalAssetsLoading } =
    useGetDigitalAssetsReport();
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);

  interface IAllDigitalAssets {
    officeName: string;
    brand: string;
    officeCode: string;
    storeNumber: string;
    officeStatus: string;
    officeType: string;
    sales_Type__c: string;
    name: string;
    address: string;
    zipCode: string;
    digital_Tracking_Number__C: string;
    website__C: string;
    page_Title__C: string;
    page_Title_Spa__C: string;
    title_Tag__C: string;
    title_Tag_Spa__C: string;
    facebook_Username_Page_Url__C: string;
    directory_General_Description__C: string;
    directory_Company_Story__C: string;
    facebook_Company_Overview__C: string;
    google_Business_Url__C: string;
    google_Description__C: string;
    meta_Description__C: string;
    meta_Description_Spa__C: string;
    page_Description__C: string;
    page_Description_Spa__C: string;
    yelp_Profile_Url__C: string;
    yelp_Description_Specialties__C: string;
  }
  //For downloading table data
  const exportdata = allDigitalAssets?.map((dga: IAllDigitalAssets) => {
    return {
      "Office Name": dga.officeName,
      Brand: dga.brand,
      "Office Code": dga.officeCode,
      "Corporate Office #": dga.storeNumber,
      "Office Status": dga.officeStatus,
      Type: dga.officeType,
      SalesType: dga.sales_Type__c,
      Name: dga.name,
      Street: dga.address,
      "Zip Code": dga.zipCode,
      "Digital Tracking Number": dga.digital_Tracking_Number__C,
      Website: dga.website__C,
      "Page Title": dga.page_Title__C,
      "Page Title SPA": dga.page_Title_Spa__C,
      "Title Tag": dga.title_Tag__C,
      "Title Tag SPA": dga.title_Tag_Spa__C,
      "Facebook Username - Page URL": dga.facebook_Username_Page_Url__C,
      "Directory General Description":
        dga.directory_General_Description__C?.replace(/"/g, "'"),
      "Directory Company Story": dga.directory_Company_Story__C?.replace(
        /"/g,
        "'"
      ),
      "Facebook Company Overview": dga.facebook_Company_Overview__C?.replace(
        /"/g,
        "'"
      ),
      "Google Business URL": dga.google_Business_Url__C,
      "Google Description": dga.google_Description__C?.replace(/"/g, "'"),
      "Meta Description": dga.meta_Description__C?.replace(/"/g, "'"),
      "Meta Description SPA": dga.meta_Description_Spa__C?.replace(/"/g, "'"),
      "Page Description": dga.page_Description__C?.replace(/"/g, "'"),
      "Page Description SPA": dga.page_Description_Spa__C?.replace(/"/g, "'"),
      "Yelp Profile URL": dga.yelp_Profile_Url__C,
      "Yelp Description (Specialties)":
        dga.yelp_Description_Specialties__C?.replace(/"/g, "'"),
    };
  });
  let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();
  const csvReport = {
    filename: "AllDigitalAssets_" + dateTimeToday + ".csv",
    data: exportdata ? exportdata : [],
  };

  const officeColumns = [
    {
      title: "Office Name",
      field: "officeName",
      render: (rowData) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              const url = "/officesettings/officesetting";
              history.push({
                pathname: url,
                state: {
                  officeCode: rowData?.officeCode,
                  officeName: rowData?.officeName,
                  action: "DigitalAssetReports",
                },
              });
              window.location.reload();
              let userTabs = [
                {
                  to: "",
                },
              ];
              [...OfficeTabs].forEach((tabs) => {
                let temp = [...userPermissions].filter(
                  (user) => user === tabs.permission
                );
                if (temp?.length > 0)
                  userTabs.push({
                    to: tabs.to,
                  });
              });
              userTabs.shift();
              const index = userTabs.findIndex((c) => c.to === url);
              setSelectedIndex(index);
            }}
          >
            <span className="text-quinary  font-bold underline text-sm ">
              {rowData.officeName}
            </span>
          </div>
        );
      },
    },
    { title: "Brand", field: "brand" },
    { title: "Office Code", field: "officeCode" },
    { title: "Corporate Office #", field: "storeNumber" },
    { title: "Office Status", field: "officeStatus" },
    { title: "Type", field: "officeType" },
    { title: "SalesType", field: "sales_Type__c" },
    {
      title: "Name",
      field: "name",
      render: (rowDetails) => {
        return (
          <div>
            <span className=" ">{rowDetails.name}</span>
          </div>
        );
      },
    },
    { title: "Street", field: "address" },
    { title: "Zip Code", field: "zipCode" },
    { title: "Digital Tracking Number", field: "digital_Tracking_Number__C" },
    { title: "Website", field: "website__C" },
    { title: "Page Title", field: "page_Title__C" },
    { title: "Page Title SPA", field: "page_Title_Spa__C" },
    { title: "Title Tag", field: "title_Tag__C" },
    { title: "Title Tag SPA", field: "title_Tag_Spa__C" },
    {
      title: "Facebook Username - Page URL",
      field: "facebook_Username_Page_Url__C",
    },
    {
      title: "Directory General Description",
      field: "directory_General_Description__C",
      render: (rowData) => {
        return (
          <div className="">
            {rowData.directory_General_Description__C?.length > 95 ? (
              <span
                data-tip={rowData.directory_General_Description__C}
                data-for={"dgdid"}
              >
                <Tooltip
                  place="right"
                  className="daTooltip"
                  id="dgdid"
                  effect="solid"
                  border={true}
                  arrowColor="#0078d7"
                  borderColor="#0078d7"
                  backgroundColor="bg-blue-600"
                  textColor="#0078d7"
                />

                {rowData.directory_General_Description__C
                  .substring(0, 95)
                  .trim() + "..."}
              </span>
            ) : (
              rowData.directory_General_Description__C
            )}
          </div>
        );
      },
    },
    {
      title: "Directory Company Story",
      field: "directory_Company_Story__C",
      render: (rowData) => {
        return (
          <div className="">
            {rowData.directory_Company_Story__C?.length > 95 ? (
              <span
                data-tip={rowData.directory_Company_Story__C}
                data-for={"dcsid"}
              >
                <Tooltip
                  place="right"
                  className="daTooltip"
                  id="dcsid"
                  effect="solid"
                  border={true}
                  arrowColor="#0078d7"
                  borderColor="#0078d7"
                  backgroundColor="bg-blue-600"
                  textColor="#0078d7"
                />
                {rowData.directory_Company_Story__C.substring(0, 95).trim() +
                  "..."}
              </span>
            ) : (
              rowData.directory_Company_Story__C
            )}
          </div>
        );
      },
    },
    {
      title: "Facebook Company Overview",
      field: "facebook_Company_Overview__C",
      render: (rowData) => {
        return (
          <div className="">
            {rowData.facebook_Company_Overview__C?.length > 95 ? (
              <span
                data-tip={rowData.facebook_Company_Overview__C}
                data-for={"fcoid"}
              >
                <Tooltip
                  place="right"
                  className="daTooltip"
                  id="fcoid"
                  effect="solid"
                  border={true}
                  arrowColor="#0078d7"
                  borderColor="#0078d7"
                  backgroundColor="bg-blue-600"
                  textColor="#0078d7"
                />
                {rowData.facebook_Company_Overview__C.substring(0, 95).trim() +
                  "..."}
              </span>
            ) : (
              rowData.facebook_Company_Overview__C
            )}
          </div>
        );
      },
    },
    { title: "Google Business URL", field: "google_Business_Url__C" },

    {
      title: "Google Description",
      field: "google_Description__C",
      render: (rowData) => {
        return (
          <div className="">
            {rowData.google_Description__C?.length > 95 ? (
              <span data-tip={rowData.google_Description__C} data-for={"gdid"}>
                <Tooltip
                  place="right"
                  className="daTooltip"
                  id="gdid"
                  effect="solid"
                  border={true}
                  arrowColor="#0078d7"
                  borderColor="#0078d7"
                  backgroundColor="bg-blue-600"
                  textColor="#0078d7"
                />
                {rowData.google_Description__C.substring(0, 95).trim() + "..."}
              </span>
            ) : (
              rowData.google_Description__C
            )}
          </div>
        );
      },
    },
    {
      title: "Meta Description",
      field: "meta_Description__C",
      render: (rowData) => {
        return (
          <div className="">
            {rowData.meta_Description__C?.length > 95 ? (
              <span data-tip={rowData.meta_Description__C} data-for={"mdid"}>
                <Tooltip
                  place="right"
                  className="daTooltip"
                  id="mdid"
                  effect="solid"
                  border={true}
                  arrowColor="#0078d7"
                  borderColor="#0078d7"
                  backgroundColor="bg-blue-600"
                  textColor="#0078d7"
                />
                {rowData.meta_Description__C.substring(0, 95).trim() + "..."}
              </span>
            ) : (
              rowData.meta_Description__C
            )}
          </div>
        );
      },
    },
    {
      title: "Meta Description SPA",
      field: "meta_Description_Spa__C",
      render: (rowData) => {
        return (
          <div className="">
            {rowData.meta_Description_Spa__C?.length > 95 ? (
              <span
                data-tip={rowData.meta_Description_Spa__C}
                data-for={"mdsid"}
              >
                <Tooltip
                  place="right"
                  className="daTooltip"
                  id="mdsid"
                  effect="solid"
                  border={true}
                  arrowColor="#0078d7"
                  borderColor="#0078d7"
                  backgroundColor="bg-blue-600"
                  textColor="#0078d7"
                />
                {rowData.meta_Description_Spa__C.substring(0, 95).trim() +
                  "..."}
              </span>
            ) : (
              rowData.meta_Description_Spa__C
            )}
          </div>
        );
      },
    },
    {
      title: "Page Description",
      field: "page_Description__C",
      render: (rowData) => {
        return (
          <div className="">
            {rowData.page_Description__C?.length > 95 ? (
              <span data-tip={rowData.page_Description__C} data-for={"pdid"}>
                <Tooltip
                  place="right"
                  className="daTooltip"
                  id="pdid"
                  effect="solid"
                  border={true}
                  arrowColor="#0078d7"
                  borderColor="#0078d7"
                  backgroundColor="bg-blue-600"
                  textColor="#0078d7"
                />
                {rowData.page_Description__C.substring(0, 95).trim() + "..."}
              </span>
            ) : (
              rowData.page_Description__C
            )}
          </div>
        );
      },
    },
    {
      title: "Page Description SPA",
      field: "page_Description_Spa__C",
      render: (rowData) => {
        return (
          <div className="">
            {rowData.page_Description_Spa__C?.length > 95 ? (
              <span
                data-tip={rowData.page_Description_Spa__C}
                data-for={"pdsid"}
              >
                <Tooltip
                  place="right"
                  className="daTooltip"
                  id="pdsid"
                  effect="solid"
                  border={true}
                  arrowColor="#0078d7"
                  borderColor="#0078d7"
                  backgroundColor="bg-blue-600"
                  textColor="#0078d7"
                />
                {rowData.page_Description_Spa__C.substring(0, 95).trim() +
                  "..."}
              </span>
            ) : (
              rowData.page_Description_Spa__C
            )}
          </div>
        );
      },
    },
    { title: "Yelp Profile URL", field: "yelp_Profile_Url__C" },
    {
      title: "Yelp Description (Specialties)",
      field: "yelp_Description_Specialties__C",
      render: (rowData) => {
        return (
          <div className="">
            {rowData.yelp_Description_Specialties__C?.length > 95 ? (
              <span
                data-tip={rowData.yelp_Description_Specialties__C}
                data-for={"ydsid"}
              >
                <Tooltip
                  place="right"
                  className="daTooltip"
                  id="ydsid"
                  effect="solid"
                  border={true}
                  arrowColor="#0078d7"
                  borderColor="#0078d7"
                  backgroundColor="bg-blue-600"
                  textColor="#0078d7"
                />
                {rowData.yelp_Description_Specialties__C
                  .substring(0, 95)
                  .trim() + "..."}
              </span>
            ) : (
              rowData.yelp_Description_Specialties__C
            )}
          </div>
        );
      },
    },
  ];

  return (
    <div className="py-4 px-8 items-center">
      <div className="">
        <div className="overflow-x-auto">
          <div>
            <div className="flex gap-2 items-center">
              <div>
                <PresentationChartLineIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
              </div>
              <div className="flex flex-col leading tight">
                <h3 className="text-xs font-medium text-gray-500">
                  Reports Module: Office with Digital Assets
                </h3>
                <h1 className="mr-auto font-bold text-primary text-md uppercase">
                  DIGITAL ASSETS REPORT
                </h1>
              </div>
            </div>
          </div>
          <div className="mt-2 " />
          <div className="flex justify-between">
            <div>
              <span className="text-gray-500 text-sm">Total Records: </span>
              <span className="text-primary text-base font-semibold">
                {allDigitalAssets?.length}
              </span>
            </div>
            <CSVLink {...csvReport}>
              <DownloadButton
                buttonValue="Download File"
                onClick={() => exportdata()}
                className={undefined}
                disabled={undefined}
              />
            </CSVLink>
          </div>
        </div>
        <div className="mt-2 mb-4 h-1 w-full border-b-2 border-secondary " />

        <div className="overflow-x-auto grid grid-row box-shadow">
          <MaterialTableTS
            data={allDigitalAssets}
            isLoading={allDigitalAssetsLoading}
            columns={officeColumns}
            showTitle={false}
          />
        </div>
      </div>
    </div>
  );
};
